import { ImageIcon, Users, Zap } from "lucide-react";
import type { LucideIcon } from "lucide-react";

// Stats are hand-curated values the team can bump as the product grows.
// Numbers tick up from 0 when the strip scrolls into view (see SocialProofStrip).
// Labels go through i18n (landing.social*Label). Icons are Lucide SVGs — never
// emojis, per the No-Emoji-Icons rule.

interface BaseStat {
  icon: LucideIcon;
}

interface CountStat extends BaseStat {
  kind: "count";
  target: number;
  suffix?: string;
  labelKey: "socialImagesLabel" | "socialCreatorsLabel";
}

interface StaticStat extends BaseStat {
  kind: "static";
  value: string;
  labelKey: "socialSpeedLabel";
}

export type SocialStat = CountStat | StaticStat;

export const SOCIAL_STATS: SocialStat[] = [
  { kind: "count", target: 36000, suffix: "+", icon: ImageIcon, labelKey: "socialImagesLabel" },
  { kind: "count", target: 2000, suffix: "+", icon: Users, labelKey: "socialCreatorsLabel" },
  // "~60s" reads correctly in both LTR and RTL — a literal "<" flips in HE.
  { kind: "static", value: "~60s", icon: Zap, labelKey: "socialSpeedLabel" },
];

// Duration of the count-up animation when the strip enters the viewport.
export const COUNT_UP_DURATION_MS = 1600;
